__turbopack_context__.v({
  "actionsColumn": "ResultView-module-scss-module__DFT7DG__actionsColumn",
  "button": "ResultView-module-scss-module__DFT7DG__button",
  "buttonPrimary": "ResultView-module-scss-module__DFT7DG__buttonPrimary",
  "buttonRow": "ResultView-module-scss-module__DFT7DG__buttonRow",
  "buttonSecondary": "ResultView-module-scss-module__DFT7DG__buttonSecondary",
  "container": "ResultView-module-scss-module__DFT7DG__container",
  "enter": "ResultView-module-scss-module__DFT7DG__enter",
  "exit": "ResultView-module-scss-module__DFT7DG__exit",
  "fade-in": "ResultView-module-scss-module__DFT7DG__fade-in",
  "fade-out": "ResultView-module-scss-module__DFT7DG__fade-out",
  "fade-out-80": "ResultView-module-scss-module__DFT7DG__fade-out-80",
  "fallbackBadge": "ResultView-module-scss-module__DFT7DG__fallbackBadge",
  "headline": "ResultView-module-scss-module__DFT7DG__headline",
  "headlineLine": "ResultView-module-scss-module__DFT7DG__headlineLine",
  "image": "ResultView-module-scss-module__DFT7DG__image",
  "imageColumn": "ResultView-module-scss-module__DFT7DG__imageColumn",
  "imageWrap": "ResultView-module-scss-module__DFT7DG__imageWrap",
  "slide-in-from-bottom": "ResultView-module-scss-module__DFT7DG__slide-in-from-bottom",
  "slide-in-from-left": "ResultView-module-scss-module__DFT7DG__slide-in-from-left",
  "slide-in-from-right": "ResultView-module-scss-module__DFT7DG__slide-in-from-right",
  "slide-in-from-top": "ResultView-module-scss-module__DFT7DG__slide-in-from-top",
  "slide-out-to-bottom": "ResultView-module-scss-module__DFT7DG__slide-out-to-bottom",
  "slide-out-to-left": "ResultView-module-scss-module__DFT7DG__slide-out-to-left",
  "slide-out-to-right": "ResultView-module-scss-module__DFT7DG__slide-out-to-right",
  "slide-out-to-top": "ResultView-module-scss-module__DFT7DG__slide-out-to-top",
  "subhead": "ResultView-module-scss-module__DFT7DG__subhead",
  "subheadAccent": "ResultView-module-scss-module__DFT7DG__subheadAccent",
  "subheadLine": "ResultView-module-scss-module__DFT7DG__subheadLine",
  "zoom-in": "ResultView-module-scss-module__DFT7DG__zoom-in",
  "zoom-out": "ResultView-module-scss-module__DFT7DG__zoom-out",
});
